//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contentHearder from '../../components/content-hearder';
import { gettemplatelist, deletetemplate } from '@/api/templateManagement.js';
export default {
  components: {
    contentHearder,
  },
  data() {
    return {
      tableData: [],
      page_index: 1,
      page_size: 10,
      total: 0,
      loading: false,
      allData: [], // 总共数据
      appid: this.$route.query.appid,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleCurrent(val) {
      this.page_index = val;
      this.tableData = this.allData.slice(
        (this.page_index - 1) * this.page_size,
        val * this.page_size,
      );
    },
    // 获取代码模板列表
    getList() {
      this.loading = true;
      gettemplatelist({ app_id: this.appid })
        .then((res) => {
          this.allData = res.list || [];
          this.tableData = this.allData.slice(0, 10);
          this.total = this.allData.length;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.errmsg);
        });
    },
    // 删除指定模板
    handleDel(val) {
      this.$confirm('确定删除吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deletetemplate({
            appid: this.appid,
            path: '/wxa/deletetemplate',
            body: JSON.stringify({ template_id: Number(val) }),
          })
            .then(() => {
              this.$message.success('删除成功！');
              this.getList();
            })
            .catch(() => {
              this.$message.success('删除失败！');
            });
        })
        .catch(() => {});
    },
  },
};
